import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isAssociation } from '../../utils/Statuts.MetierAsso.constant';

const InformationsPersonneMoraleEtablissement = ({
    informationsEtablissement,
    federation,
    sousStatut,
    typeMetier,
}) => {
    return (
        <>
            <p className="margin-bottom-sm gras">{informationsEtablissement.raisonSociale}</p>
            <p className="margin-bottom-sm">
                N°<abbr> {informationsEtablissement.typeIdEntreprise}</abbr> :{' '}
                {informationsEtablissement.numIdEntreprise}
            </p>

            <p className="margin-bottom-sm">
                {isAssociation(sousStatut)
                    ? `Fédération de rattachement : ${federation ?? 'Aucune affiliation'}`
                    : `Type de métier : ${typeMetier}`}
            </p>
        </>
    );
};

InformationsPersonneMoraleEtablissement.propTypes = {
    informationsEtablissement: PropTypes.shape({
        raisonSociale: PropTypes.string,
        numIdEntreprise: PropTypes.string,
        typeIdEntreprise: PropTypes.string,
    }),
    federation: PropTypes.string,
    sousStatut: PropTypes.string,
    typeMetier: PropTypes.string,
};

export default connect()(InformationsPersonneMoraleEtablissement);
